module.exports = __webpack_public_path__ + "VIPH11.png?430d36f3e85676b4ef098612014fdeca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH11.png
// module id = 83
// module chunks = 0